import store from '@/store/index.js';
import smSellApi from './smSellApi.js';
import smCom from '../global/smCom.js'
import timeHelper from '../global/timeHelper.js';


//判断增值
const GetSmAddVal = async (appId) => {
  // 是  1001  不做权限
  let idx = store.state.smSellAdmin.shop_app_info.findIndex(item => {
    return item.app_id == appId
  })
  if (idx != -1) {
    return true
  } else {
    return false
  }
}




const fCloudImgManger = async (searchStr, pageNo, pageSize) => {
  let js = {};

  js['OPER'] = 'GET';
  js['IMG_TYPE'] = 'PRO_MAIN';
  js['SEARCH_STR'] = searchStr;
  js['PAGE_NO'] = pageNo;
  js['PAGE_SIZE'] = pageSize;
  let res = await smSellApi.fPostToSmSellMainSrvApi('CLOUD_IMG_MANGER', js, 'QINIU')
  return res;
};

// 判断是否拥有权限
const fGetSmMenuQx = async (menu) => {
  // 是  1001  不做权限
  if (store.state.smSellAdmin.userId == '1001' || !menu) {
    return {
      qx_name: menu,
      resolve: true
    }
  }

  let idx = store.state.smSellAdmin.qxList.findIndex(item => {
    return item.qx_name == menu
  })
  if (idx != -1) {
    return {
      qx_name: menu,
      resolve: true
    }
  } else {
    return {
      qx_name: menu,
      resolve: false
    }
  }
}


//图片管理
const fImgManger = async (oper, obj, type) => {
  let js = {};
  // ADD DEL
  js['OPER'] = oper
  js['TYPE_MARK'] = obj.type_mark
  js['MALL_ID'] = obj.mall_id
  js['PRO_ID'] = obj.pro_id
  js['IMG_NAME'] = obj.img_name
  js['TO_PAGE'] = obj.to_page
  js['GL_MALL_ID'] = obj.gl_mall_id
  js['URL'] = obj.url
  js['TO_URL'] = obj.to_url
  js['CHG_PERSON'] = '1001' //store.state.
  js['USER_MEMO'] = obj.user_memo
  js['ASC_DESC'] = obj.asc_desc
  if (type == 'btn') {
    js['TO_URL'] = obj.path
  }

  let res = await smSellApi.fPostToSmSellAdminApi('IMG_MANGER', js)
  return res;

}
//自动生成编码编码
const fGetAutoCode = async (oper, clsId) => {
  let js = {};
  js['OPER'] = oper;
  js['CLS_ID'] = clsId;
  js['AREA_ID'] = store.state.smSellAdmin.areaId;
  // js['SEARCH_STR'] = obj.searchStr;
  let res = await smSellApi.fPostToSmSellQueryApi('GET_AUTO_CODE', js)
  return res;
}
//获取供应商信息
const fGetGysInfo = async (obj) => {
  // GYS_LIST GYS_ID
  let js = {};
  js['OPER'] = obj.oper;
  js['MALL_ID'] = obj.mallId || store.state.smSellAdmin.shMallId;
  js['CLS_ID'] = obj.clsId || '00';
  js['SEARCH_STR'] = obj.searchStr;
  // if (obj.oper == 'GYS_ID') {
  //   js['SEARCH_STR'] = obj.gysId;
  // }
  js['PAGE_SIZE'] = obj.pageSize + '';
  js['NOW_PAGE'] = obj.nowPage + '';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y";
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  js['ORDER_BY'] = obj.orderBy
  let res = await smSellApi.fPostToSmSellQueryApi('GET_GYS_INFO', js)
  return res;
}

//获取门店信息
const fGetMallInfo = async (obj) => {
  let js = {};
  // MALL_ID
  js['OPER'] = obj.oper;
  js['MALL_ID'] = obj.mallId || store.state.smSellAdmin.shMallId;
  js['CLS_ID'] = obj.clsId || '00';
  js['SEARCH_STR'] = obj.userId || obj.searchStr || '';
  js['PAGE_SIZE'] = obj.pageSize || 100;
  js['NOW_PAGE'] = obj.nowPage + '';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y";
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  js['ORDER_BY'] = obj.orderBy
  js['ONLINE_SHOW'] = obj.onlineShow
  js['CLS_CLS_ID'] = obj.clsClsId
  js['CLS_TYPE'] = obj.clsType
  js['USER_MALL_QX_YN'] = obj.userMallQxYn || 'Y'

  // load_url
  let res = await smSellApi.fPostToSmSellQueryApi('GET_MALL_INFO', js, obj.fwqIp || '', obj.load_url, obj.shPhone,
    obj.userId)
  return res;
}

//获取员工信息
const fGetUserInfo = async (obj) => {
  let js = {};
  // USER_LIST  user_list  USER_ID
  js['OPER'] = obj.oper;
  js['MALL_ID'] = obj.mallId || store.state.smSellAdmin.shMallId;
  js['CLS_ID'] = obj.clsId || '00';
  js['SEARCH_STR'] = obj.userId || obj.searchStr;
  js['PAGE_SIZE'] = obj.pageSize + '';
  js['NOW_PAGE'] = obj.nowPage + '';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y";
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  js['ORDER_BY'] = obj.orderBy
  let res = await smSellApi.fPostToSmSellQueryApi('GET_USER_INFO', js, obj.fwqIp || '', obj.load_url, obj.shPhone,
    obj.userId)
  return res;
}
const fGetWgoProClsData = async (oper, clsId, zcYn) => {
  let js = {};
  js['OPER'] = oper;
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  js['CLS_ID'] = clsId || '00';
  js['ZC_YN'] = zcYn ? "N" : "Y"
  let res = await smSellApi.fPostToSmSellWgoApi('GET_WGO_PRO_CLS_DATA', js)
  return res;
}
//获取分类
const fGetClsInfo = async (type, oper, clsId, zcYn, onlineShow) => {
  let methodName = ''
  if (type == 'PRO') {
    methodName = 'GET_PRO_CLS_DATA'
  }
  if (type == 'WGO_PRO') {
    methodName = 'GET_WGO_PRO_CLS_DATA'
  }
  if (type == 'GYS') {
    methodName = 'GET_GYS_CLS_INFO'
  }
  if (type == 'USER') {
    methodName = 'GET_USER_CLS_INFO'
  }
  if (type == 'MALL') {
    methodName = 'GET_MALL_CLS_INFO'
  }
  if (type == 'VIP') {
    methodName = 'GET_VIP_CLS_INFO'
  }
  if (type == 'KQ') {
    methodName = 'GET_KQ_CLS_INFO'
  }
  if (type == 'KH') {
    methodName = 'GET_KH_CLS_INFO'
  }
  if (type == 'COLOR') {
    methodName = 'GET_COLOR_CLS_INFO'
  }
  if (type == 'SIZE') {
    methodName = 'GET_SIZE_CLS_INFO'
  }
  if (type == 'TABLE') {
    methodName = 'GET_CY_TABLE_CLS_INFO'
  }
  let js = {};
  js['OPER'] = oper;
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  js['CLS_ID'] = clsId || '00';
  js['ZC_YN'] = zcYn ? "N" : "Y"
  js['ONLINE_SHOW_YN'] = onlineShow
  let res = await smSellApi.fPostToSmSellQueryApi(methodName, js)
  return res;
}
//获取商品信息
const fGetProInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['MALL_ID'] = obj.mallId || store.state.smSellAdmin.shMallId;
  js['CLS_ID'] = obj.clsId || '00';
  js['GYS_ID'] = obj.gys_id || '';
  js['USER_ID'] = obj.user_id || '';
  js['PP_ID'] = obj.pp_id || '';
  js['SEARCH_STR'] = obj.searchStr;
  js['PAGE_SIZE'] = obj.pageSize || '50';
  js['NOW_PAGE'] = obj.nowPage || '1';
  js['ZC_YN'] = obj.zcYn == '全部' ? obj.zcYn : (obj.zcYn ? "N" : "Y");
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  js['ORDER_BY'] = obj.orderBy
  js['PRO_TYPE'] = obj.proType || ''
  js['PRICE_WAY'] = obj.priceWay
  js['STATE'] = obj.state
  console.log(js)
  let res = await smSellApi.fPostToSmSellQueryApi('GET_PRO_INFO', js)
  return res;
}
//获取品牌信息
const fGetPpInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['MALL_ID'] = obj.mallId || store.state.smSellAdmin.shMallId;
  // js['CLS_ID'] = obj.clsId || '00';
  js['SEARCH_STR'] = obj.searchStr;
  // js['PAGE_SIZE'] = obj.pageSize || '50';
  // js['NOW_PAGE'] = obj.nowPage || '1';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y";
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  // js['ORDER_BY'] = obj.orderBy
  js['ORDER_BY'] = ''

  let res = await smSellApi.fPostToSmSellQueryApi('GET_PP_INFO', js)

  return res;
}
//获取标签打印和散装传称 最近变动商品
const fGetLastChgPro = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['MALL_ID'] = obj.mallId || store.state.smSellAdmin.shMallId;
  // js['CLS_ID'] = obj.clsId || '00';
  js['SEARCH_STR'] = obj.searchStr;
  js['PAGE_SIZE'] = obj.pageSize || '50';
  js['NOW_PAGE'] = obj.nowPage || '1';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y";
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  js['ORDER_BY'] = obj.orderBy

  let res = await smSellApi.fPostToSmSellQueryApi('GET_LAST_CHG_PRO', js)

  return res;
}
//获取下拉框内容
const fGetBaseInfo = async (oper, searchStr, dcMallId, drMallId, noClsTopYn, gysId, khId) => {
  // 商品类别
  // PRO_CLS_INFO
  // // 供应商类别
  // GYS_CLS_INFO
  // // 客户类别
  // KH_CLS_INFO
  // // 会员类别
  // VIP_CLS_INFO
  // // 员工类别
  // USER_CLS_INFO
  // // 供应商
  // GYS_INFO
  // // 商品
  // PRO_INFO
  // // 品牌
  // PRO_PP_INFO
  // // 客户
  // KH_INFO
  // // 会员
  // VIP_INFO
  // // 资金账户
  // SK_ZH_INFO
  // // 门店
  // MALL_INFO
  // // 员工
  // USER_INFO
  let js = {};
  js['OPER'] = oper;
  js['MALL_ID'] = dcMallId || store.state.smSellAdmin.shMallId;
  js['NO_CLS_TOP_YN'] = noClsTopYn || 'N'
  js['PAGE_SIZE'] = '100';
  js['NOW_PAGE'] = '1';
  js['SEARCH_STR'] = searchStr;
  js['GYS_ID'] = gysId || ''
  js['KH_ID'] = khId || ''
  js['DR_MALL_ID'] = drMallId || ''
  js['MH_YN'] = "Y"
  js['USER_ID'] = store.state.smSellAdmin.userId
  if (searchStr == '返回全部门店') {
    js['USER_ID'] = '1001'
  }
  let res = await smSellApi.fPostToSmSellQueryApi('GET_BASE_INFO', js)
  return res;
}
const fGetBaseData = async (oper) => {

  let js = {};
  js['OPER'] = oper;
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  js['PAGE_SIZE'] = '50';
  js['NOW_PAGE'] = '1';
  js['CHG_TIME'] = '2020-01-01 00:00:00';
  // js['SEARCH_STR'] = obj.searchStr;

  let res = await smSellApi.fPostToSmSellQueryApi('GET_BASE_DATA', js)
  return res;
}
// 获取多单位
const fGetProUnit = async (id, oper) => {
  let js = {};
  js['OPER'] = oper || 'UNIT_LIST';
  js['PRO_ID'] = id
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  js['SEARCH_STR'] = ''
  js['PAGE_SIZE'] = '100';
  js['NOW_PAGE'] = '1';
  js['MH_YN'] = 'Y';
  js['ZC_YN'] = 'Y'
  js['ORDER_BY'] = ''
  let res = await smSellApi.fPostToSmSellQueryApi('GET_PRO_UNIT', js)
  return res;
}
//获取商品颜色尺码组合信息
const fGetProColorSizeInfo = async (proId, zcYn) => {
  let js = {};
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  js['PRO_ID'] = proId
  js['SEARCH_STR'] = ''
  js['ZC_YN'] = zcYn
  js['MH_YN'] = 'Y'
  js['PAGE_SIZE'] = '300'
  js['NOW_PAGE'] = '1'
  js['ORDER_BY'] = ''
  let res = await smSellApi.fPostToSmSellQueryApi('GET_PRO_COLOR_SIZE_INFO', js)
  return res
}
// 获取数据导入结果
const fGetImportDetail = async (obj) => {
  // psOper   := 'PRO_CLS'   //商品分类
  // psOper   := 'PRO_PP'    //品牌分类
  // psOper   := 'GYS_CLS'   //供应商分类
  // psOper   := 'KH_CLS'    //客户分类
  // psOper   := 'PRO'       //商品
  // psOper   := 'GYS'      //供应商
  // psOper   := 'KH'       //客户
  // psOper   := 'VIP'      //会员
  // psOper   := 'PRO_IMG'; // 商品图片
  let js = {};
  js['OPER'] = obj.oper
  js['PAGE_SIZE'] = obj.pageSize
  js['NOW_PAGE'] = obj.nowPage
  js['ORDER_BY'] = ''
  let res = await smSellApi.fPostToSmSellQueryApi('GET_IMPORT_DETAIL', js)
  return res
}
// 账户
const fGetZjzhSimInfo = async () => {
  // ZJZH_LIST，ZJZH_NAME
  let js = {};
  js['OPER'] = 'ZJZH_LIST_SIM';
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  js['SEARCH_STR'] = '';
  js['PAGE_SIZE'] = 100;
  js['NOW_PAGE'] = 1;
  js['ZC_YN'] = "Y";
  js['MH_YN'] = "Y";
  js['GET_LIST'] = 'ht_use_yn'
  let res = await smSellApi.fPostToSmSellQueryApi('GET_ZJZH_INFO', js)
  return res;
}
//获取商品
const fGetWgoProInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  js['CLS_ID'] = obj.clsId || '00';
  js['GYS_ID'] = obj.gys_id || '';
  js['PP_ID'] = obj.pp_id || '';
  js['SEARCH_STR'] = obj.searchStr;
  js['PAGE_SIZE'] = obj.pageSize || '50';
  js['NOW_PAGE'] = obj.nowPage || '1';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y";
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  js['ORDER_BY'] = obj.orderBy
  js['PRO_TYPE'] = obj.proType || ''
  js['PRICE_WAY'] = obj.priceWay
  js['ONLINE_STATE'] = '已上架'
  let res = await smSellApi.fPostToSmSellWgoApi('GET_WGO_PRO_INFO', js)
  return res;
};

const fGetMallProQuery = async (obj) => {
  let js = {};
  js['MALL_ID'] = store.state.smSellAdmin.shMallId;
  if (obj.title == '采购单据') {
    js['GYS_ID'] = obj.ksId;
  }
  if (obj.title == '批发单据') {
    js['KH_ID'] = obj.ksId;
  }
  if (obj.title == '门店调货单据') {
    js['DR_MALL_ID'] = obj.ksId;
    js['MALL_ID'] = obj.outMallId
  }
  js['SEARCH_STR'] = obj.searchStr || '';
  js['MH_YN'] = "Y"
  js['PAGE_SIZE'] = '50' //obj.page.pageSize
  js['NOW_PAGE'] = '1' //obj.page.nowPage
  js['ORDER_BY'] = ""
  let res = await smSellApi.fPostToSmSellQueryApi('GET_MALL_PRO_QUERY', js)
  return res;
}

const fGetJmMallClsInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['CLS_ID'] = obj.clsId || '00';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y"
  let res = await smSellApi.fPostToSmSellQueryApi('GET_JM_MALL_CLS_INFO', js)
  return res;
}
const fGetJmProClsInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['CLS_ID'] = obj.clsId || '00';
  js['ZC_YN'] = obj.zcYn ? "N" : "Y"
  js['SUP_MCH_ID'] = obj.sup_mch_id

  let res = await smSellApi.fPostToSmSellQueryApi('GET_JM_PRO_CLS_INFO', js)
  return res;
}
const fGetJmSupProInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['CLS_ID'] = obj.clsId || '00';
  js['SUB_MCH_ID'] = obj.sub_mch_id
  js['SUB_MALL_ID'] = obj.sub_mall_id
  js['PRO_ID_LIST'] = obj.pro_id_list

  js['SUP_MCH_ID'] = obj.sup_mch_id
  js['SUP_MALL_ID'] = obj.sup_mall_id
  js['JM_CLS_ID'] = obj.jm_cls_id
  js['PRO_ID'] = ''
  js['SEARCH_STR'] = obj.searchStr || '';
  js['MH_YN'] = obj.mhYn || true ? "Y" : "N"
  js['PAGE_SIZE'] = obj.pageSize || 50 //obj.page.pageSize
  js['NOW_PAGE'] = obj.nowPage //obj.page.nowPage
  js['ZC_YN'] = obj.zcYn ? "N" : "Y"
  js['ORDER_BY'] = obj.orderBy
  let res;
  if (obj.ipYn == 'Y') {
    res = await smSellApi.fPostToSmSellQueryApi('JM_DATA_SUB_TO_SUP', js, obj.sub_mch_ip, obj.load_url, obj
      .sub_mch_id, '', 'smSell719ee78131675d5ed4cacbe41e1c8191Api')
  }
  res = await smSellApi.fPostToSmSellQueryApi('GET_JM_SUP_PRO_INFO', js)
  return res;
}
//门店增删改查
const fJmMallInfo = async (obj) => {
  let js = {}
  js['OPER'] = obj.oper
  js['SUB_MCH_ID'] = obj.sub_mch_id
  js['SUB_MALL_ID'] = obj.sub_mall_id
  js['SUB_MALL_NAME'] = obj.sub_mall_name
  js['SUB_CLS_ID'] = obj.clsId
  js['SUP_MCH_ID'] = obj.sup_mch_id
  js['SUP_MALL_ID'] = obj.sup_mall_id
  js['SUP_MALL_NAME'] = obj.sup_mall_name
  js['SUB_BAND_USER_NAME'] = obj.sub_band_user_name
  js['SUB_NO_PASS_USER_NAME'] = obj.sub_no_pass_user_name
  js['SUB_NO_PASS_REASON'] = obj.sub_no_pass_reason
  js['SUP_UN_BAND_USER_NAME'] = obj.sup_un_band_user_name
  js['SUP_UN_BAND_REASON'] = obj.sup_un_band_reason
  js['SUP_USER_MEMO'] = obj.sup_user_memo
  js['STATE'] = obj.state || ''
  js['SUB_LNK_PERSON'] = obj.sub_lnk_person
  js['SUB_LNK_PHONE'] = obj.sub_lnk_phone
  js['SUB_ADR_PROV'] = obj.sub_adr_prov
  js['SUB_ADR_CITY'] = obj.sub_adr_city
  js['SUB_ADR_AREA'] = obj.sub_adr_area
  js['SUB_ADR'] = obj.sub_adr
  js['SUB_ADR_LAT'] = obj.sub_adr_lat
  js['SUB_ADR_LNG'] = obj.sub_adr_lng
  js['SUP_LNK_PERSON'] = ''
  js['SUP_LNK_PHONE'] = ''
  js['SUP_ADR_PROV'] = ''
  js['SUP_ADR_CITY'] = ''
  js['SUP_ADR_AREA'] = ''
  js['SUP_ADR'] = ''
  js['SUP_ADR_LAT'] = ''
  js['SUP_ADR_LNG'] = ''
  js['CHG_USER_ID'] = store.state.smSellAdmin.userId;
  let res = await smSellApi.fPostToSmSellAdminApi('JM_MALL_INFO', js)
  return res;
}
const fJmProInfo = async (obj) => {
  let js = {}
  js['OPER'] = obj.oper
  js['CHG_USER_ID'] = store.state.smSellAdmin.userId;
  js['SUP_MCH_ID'] = obj.sup_mch_id
  js['SUP_MALL_ID'] = obj.sup_mall_id
  js['SUB_MCH_ID'] = obj.sub_mch_id
  js['SUB_MALL_ID'] = obj.sub_mall_id
  js['DOWN_PRO_TYPE'] = obj.down_pro_type
  js['PRO_ID_LIST'] = obj.pro_id_list
  js['CLS_ID'] = obj.cls_id
  js['GYS_ID'] = obj.gys_id
  js['JM_CLS_ID'] = obj.jm_cls_id
  let res = await smSellApi.fPostToSmSellAdminApi('JM_PRO_INFO', js)
  return res;
}


const fGetJmProInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['CLS_ID'] = obj.clsId || '00';
  js['SUP_MCH_ID'] = obj.sup_mch_id
  js['SUP_MALL_ID'] = obj.sup_mall_id
  js['SUB_MCH_ID'] = obj.sub_mch_id
  js['SUB_MALL_ID'] = obj.sub_mall_id
  js['JM_CLS_ID'] = obj.jm_cls_id
  js['PRO_ID'] = ''
  js['PRO_ID_LIST'] = obj.pro_id_list
  js['SEARCH_STR'] = obj.searchStr || '';
  js['MH_YN'] = obj.mhYn ? "Y" : "N"
  js['PAGE_SIZE'] = obj.pageSize || 50 //obj.page.pageSize
  js['NOW_PAGE'] = obj.nowPage //obj.page.nowPage
  js['ZC_YN'] = obj.zcYn ? "N" : "Y"
  js['ORDER_BY'] = ""

  let res = await smSellApi.fPostToSmSellQueryApi('GET_JM_PRO_INFO', js)
  return res;
}

const fGetJmMchSumData = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['START_TIME'] = obj.startTime;
  js['OVER_TIME'] = obj.overTime
  js['SUP_MCH_ID'] = obj.supMchId
  js['SUP_MALL_ID'] = obj.supMallId
  js['SUB_MCH_ID'] = obj.subMchId
  js['SUB_MALL_ID'] = obj.subMallId
  js['SEARCH_STR'] = obj.searchStr || '';
  js['MH_YN'] = obj.mhYn ? "Y" : "N"
  js['PAGE_SIZE'] = obj.pageSize || 50 //obj.page.pageSize
  js['NOW_PAGE'] = obj.nowPage //obj.page.nowPage
  js['ORDER_BY'] = ""

  let res = await smSellApi.fPostToSmSellQueryApi('GET_JM_MCH_SUM_DATA', js)
  return res;
}

const fGetJmMallInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  // SUB_MALL_LIST 加盟我的列表;
  // SUB_MALL_ID 加盟我的单个门店；
  // SUP_MALL_LIST 我的加盟列表;
  // SUP_MALL_ID 我的加盟单个门店
  // js['SUP_MCH_ID'] = this.$store.state.smSellAdmin.shPhone;
  // js['SUP_MALL_ID'] = this.$store.state.smSellAdmin.shMallId;
  js['SUB_CLS_ID'] = obj.subClsId;
  js['STATE'] = obj.state; //全部、待确认、已通过、已驳回、已取消、删除
  js['SEARCH_STR'] = obj.searchStr || '';
  js['PAGE_SIZE'] = obj.pageSize || '50';
  js['NOW_PAGE'] = obj.nowPage || '1';
  js['MH_YN'] = obj.mhYn ? "Y" : "N";
  js['ORDER_BY'] = '';
  console.log(js)
  let res = await smSellApi.fPostToSmSellQueryApi('GET_JM_MALL_INFO', js)
  console.log(res)
  return res;
}


export default {
  fImgManger, //图片管理
  fGetGysInfo, //获取供应商信息
  fGetMallInfo, //获取门店信息
  fGetUserInfo, //获取员工信息
  fGetAutoCode, //创建编码
  fGetClsInfo, //获取分类信息
  fGetProInfo, // 获取商品
  fGetPpInfo, //获取品牌信息
  fGetBaseInfo, //获取下拉框内容
  fGetLastChgPro, //获取标签打印和散装传称 最近变动商品
  fGetBaseData,
  fGetProUnit, // 获取多单位
  fGetSmMenuQx, //验证权限
  fGetProColorSizeInfo, //获取商品颜色尺码组合信息
  fGetImportDetail, // 获取数据导入结果
  fGetZjzhSimInfo,
  fGetWgoProInfo,
  fCloudImgManger,
  fGetWgoProClsData,
  fGetMallProQuery,
  GetSmAddVal, //判断增值
  fGetJmMallClsInfo,
  fGetJmProClsInfo,
  fJmMallInfo,
  fGetJmSupProInfo,
  fJmProInfo,
  fGetJmProInfo,
  fGetJmMchSumData,
  fGetJmMallInfo

}



//////////////////
// WEBPACK FOOTER
// ./common/api/smCommon.js
// module id = null
// module chunks = 